import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/subject/base"

const subject = {
  subjectListPage(pageSize, limit, keyWord) {
    return axios.get(pre + `/subjectListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
        }
    });
  },
  subjectInfo(id) {
    return axios.get(pre + `/subjectInfo`, {params: {id: id}});
  },
  subjectSave(params) {
    return axios.post(pre + `/subjectSave`, qs.stringify(params));
  },
  subjectDelete(id) {
    return axios.delete(pre + `/subjectDelete`,  {params: {id: id}});
  },
}
export default subject;



// WEBPACK FOOTER //
// ./src/api/config/subject.js